<template>
    <div v-if="shown" class="pp-mobile-plays">
        <span v-if="plays > 0 ">
            {{ plays }} free tracks remaining
        </span>
        <span v-else>
            Out of free tracks.
        </span>
    </div>
</template>

<script>
export default {
    name: 'mobile-free-plays',
    props: {
        shown: Boolean,
        plays: Number
    }
}
</script>



// WEBPACK FOOTER //
// MobileFreePlays.vue?3d3160f0